package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry.AssemblyRoofPreparationProcessStates.Cancelled
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry.AssemblyRoofPreparationProcessStates.Done
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry.AssemblyRoofPreparationProcessStates.InProgress
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry.AssemblyRoofPreparationProcessStates.Missing
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.HasDueDate
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("AssemblyRoofPreparationProcessStateEntry")
data class AssemblyRoofPreparationProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: AssemblyRoofPreparationProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val dueDate: IsoMillis?,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry, HasDueDate {

  override val availableOptions: List<AssemblyRoofPreparationProcessStates>
    get() = AssemblyRoofPreparationProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return when (processState) {
      Missing -> processState.formatForScheduling(dueDate, i18nConfiguration)
      InProgress, Done, Cancelled -> processState.format(i18nConfiguration)
    }
  }

  @Serializable
  @SerialName("AssemblyRoofPreparationProcessStates")
  enum class AssemblyRoofPreparationProcessStates : LizergyProcessStates {
    Missing,
    InProgress,
    Done,
    Cancelled,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Missing -> ProcessStatePhase.Untouched
        InProgress -> ProcessStatePhase.InProgress
        Done -> ProcessStatePhase.Done
        Cancelled -> ProcessStatePhase.Rejected
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Missing -> "MD"
        InProgress -> "MD Material fehlt"
        Done -> "MD Material vorbereitet"
        Cancelled -> "MD abgesagt"
      }
    }
  }
}
